// The babel polyfill for ES6 features such as Object.assign()
import 'babel-polyfill';



// WEBPACK FOOTER //
// ./assets/js/polyfills.js